<template>
  <div>
    <section v-show="sidebarCurrentPanel === 'exibitionfrequency'" class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
      <div class="kp-modular-tab pt-page no-fade pt-page-current">
        <header class="kp-modular-title">
          {{ $t('general.labels.configurations') }}
        </header>
        <div class="submenu-content sub-color">
          <advanced-config-header></advanced-config-header>
          <advanced-config-options></advanced-config-options>
          <a
            href="#"
            class="btn"
            @click="publishAndExport()">{{ $t('general.actions.publish') }} {{ $t('general.labels.and') }} {{ $t('general.actions.export') }}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AdvancedConfigHeader from './Header.vue';
import AdvancedConfigOptions from './options/Main.vue';

export default {
  components: {
    AdvancedConfigHeader,
    AdvancedConfigOptions,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
    boxActive: 'boxActive',
  }),
  methods: {
    publishAndExport() {
      this.boxSave(true)
        .then(() => {
          this.modalOpen('code');
          this.codeSetupBox(this.boxActive);
        });
    },
    ...mapActions([
      'modalOpen',
      'codeSetupBox',
      'boxSave',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?8f7b92ee
 **/